import { Module } from 'vuex';
import RootState from '../../state';
import { accountStatusUsingGET } from '@services/merchant/ad-center-controller';
interface IPromotionState {
    adStatus: number;
}

const intialState = {
    adStatus: 0,
};

const promotionState: Module<IPromotionState, RootState> = {
    namespaced: true,
    state: intialState,
    mutations: {
        setAccountStatus(state: typeof intialState, { adStatus }) {
            state.adStatus = adStatus;
        },
    },
    actions: {
        async getAccountStatus({ commit, dispatch, state, rootState }, payload) {
            const { data } = await accountStatusUsingGET();
            const { adStatus } = data;
            commit('setAccountStatus', { adStatus });
        },
    },
    getters: {},
};

export default promotionState;
